<template>
  <div>
    <h3>Word Count</h3>
    <div id="wordCountInput">
      <v-textarea rows="8" v-model="inputText" outlined auto-grow></v-textarea>
    </div>

    <h3>Count: {{ wordCount }}</h3>
    <v-btn @click="clearInput()">Clear</v-btn>
  </div>
</template>

<script>
export default {
  computed: {
    wordCount: function() {
      const str = this.inputText.replace(/(?!\W)\S+/g, "1").replace(/\s*/g, "");
      return str.lastIndexOf("");
    }
  },
  data() {
    return {
      inputText: ""
    };
  },
  methods: {
    clearInput() {
      this.inputText = "";
    }
  }
};
</script>

<style>
#wordCountInput {
  margin: 0 100px 0 100px;
}
</style>
